import { baseUrl } from '@/environment';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MetadataService {
  constructor(
    private metaService: Meta,
    private titleService: Title,
    private router: Router,
    @Inject(DOCUMENT) private dom: Document,
  ) {}

  setPageTitle(title: string) {
    this.titleService.setTitle(title);
  }

  setMetaTags(tagsList: Array<MetaDefinition>) {
    tagsList.forEach((tag: MetaDefinition) => {
      this.metaService.updateTag(tag);
    });
  }

  initAutoCanonical(): void {
    // 1. Process current URL immediately for initial SSR render
    this.setCanonicalFromPath(this.router.url);

    // 2. Listen for subsequent client-side navigation events
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe((event: NavigationEnd) => {
        this.setCanonicalFromPath(event.urlAfterRedirects);
      });
  }

  private setCanonicalFromPath(rawPath: string): void {
    // Remove query parameters (?ref=123) and hashes (#section) for canonical URL standards
    const path = rawPath.split('?')[0].split('#')[0];

    // Ensure root route doesn't end with double slashes
    const fullCanonicalUrl =
      path === '/' || path === '' ? `${baseUrl}/` : `${baseUrl}${path}`;

    this.updateCanonicalUrl(fullCanonicalUrl);
  }

  private updateCanonicalUrl(url: string): void {
    let link: HTMLLinkElement | null = this.dom.querySelector(
      "link[rel='canonical']",
    );
    if (!link) {
      link = this.dom.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.dom.head.appendChild(link);
    }
    link.setAttribute('href', url);
  }
}
